/*
THIS FILE IS AUTO-GENERATED, NO MANUAL CHANGES IS ALLOWED
*/

import { HttpClient, type RequestParams } from '@atlas/shared/data-access/shared';
import type { ContentReportPostPayloadModel, ContentTranslationGetParamsModel } from '../models/index';
import {
    ContentServiceErrorGuards,
    type ContentReportPostErrorModel,
    type ContentTranslationGetErrorModel
} from './errors/ContentServiceErrors';

export class ContentService extends HttpClient {
    /**  ContentService API static endpoints */
    static Endpoints = {
        contentTranslationGet: '/api/content/translation',

        contentReportPost: '/api/content/report'
    };

    /**  ContentService API static errors typeguards */
    static Errors = ContentServiceErrorGuards;

    /**  ContentService API methods */
    /**
     * @description Get user translations content. Only fr scope for now.
     * @tags Content public routes
     * @name ContentTranslationGet
     * @summary Get translation
     * @request GET:/api/content/translation
     */
    contentTranslationGet = (query?: ContentTranslationGetParamsModel, requestParams: RequestParams = {}) =>
        this.request<any, ContentTranslationGetErrorModel>({
            path: ContentService.Endpoints.contentTranslationGet,
            method: 'GET',
            query: query,
            ...requestParams
        });
    /**
     * @description Report content.
     * @tags Content public routes
     * @name ContentReportPost
     * @summary Report content
     * @request POST:/api/content/report
     */
    contentReportPost = (data: ContentReportPostPayloadModel, requestParams: RequestParams = {}) =>
        this.request<any, ContentReportPostErrorModel>({
            path: ContentService.Endpoints.contentReportPost,
            method: 'POST',
            body: data,
            type: 'multipart/form-data',
            ...requestParams
        });
}

export * from './errors/ContentServiceErrors';
